import { render, staticRenderFns } from "./AdminConfigGroupStatistic.vue?vue&type=template&id=088d03ce&scoped=true&"
import script from "./AdminConfigGroupStatistic.vue?vue&type=script&lang=js&"
export * from "./AdminConfigGroupStatistic.vue?vue&type=script&lang=js&"
import style0 from "./AdminConfigGroupStatistic.vue?vue&type=style&index=0&id=088d03ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088d03ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VBtnToggle,VCard,VCardText,VCardTitle,VList,VListItem})
